<div>
  <div class="flex justify-content-center align-items-center mt-4">
    <!-- <button
            pButton
            class="btn"
            (click)="showCreateCustomer = true"
        >
            Open create
        </button> -->

    <div class="grid sm:w-9 w-full mx-auto">
      <div class="sm:col-8 col-12 mx-auto">
        <p-autoComplete
          appendTo="body"
          class="sm:w-9 w-full"
          [(ngModel)]="searchText"
          [suggestions]="customers()"
          (completeMethod)="getSearchResults()"
          [showEmptyMessage]="true"
          placeholder="Search..."
          field="name"
          (onSelect)="selectedContact = searchText"
          [dropdown]="true"
        >
          <ng-template pTemplate="header">
            <p class="p-2 bg-primary mb-0" (click)="openAddCustomerComponent()">
              <i class="pi pi-plus mr-2"></i>
              Add new
            </p>
          </ng-template>
          <ng-template let-customer pTemplate="item"> {{ customer?.name }} {{ customer?.email }} </ng-template>
        </p-autoComplete>
      </div>

      <div class="sm:col-4 col-12" *ngIf="selectedContact && !utilService.doesURLHaveText('quotes')">
        <p-button icon="pi pi-plus" label="Add Customer" (click)="emitSelectedCustomer()" class="p-button-secondary"></p-button>
      </div>
      <div class="sm:col-4 col-12" *ngIf="selectedContact && utilService.doesURLHaveText('quotes')">
        <p-button icon="pi pi-link" label="Link to Customer" class="p-button-secondary" (click)="emitSelectedCustomer()"></p-button>
      </div>
    </div>
  </div>
  <div class="flex justify-content-center mt-2" *ngIf="utilService.doesURLHaveText('quotes')">OR</div>
  <div *ngIf="utilService.doesURLHaveText('quotes')" class="flex justify-content-center mt-2">
    <button label="Save as New Customer" pButton type="button" icon="pi pi-plus" iconPos="left" (click)="emitCreateNewCustomer()"></button>
  </div>
</div>

<div class="create-customer">
  <p-dialog
    header="Create new customer"
    [(visible)]="showCreateCustomer"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '50vw' }"
    [baseZIndex]="1"
  >
    <app-create-contact></app-create-contact>
  </p-dialog>
</div>
